export const validateStampNumber = stampNumber => {
  if (stampNumber) {
    const stampNumberRegex = /^([0-9a-zA-Z]{0,2})[0-9]*$/;
    return stampNumberRegex.test(stampNumber);
  }

  return true;
};